import { apiGet, apiPost, apiPut } from '../_common';

export default {
  create(request) {
    return apiPost('/magenta/stock/product', request).then(result => result.response);
  },
  update(id, request) {
    return apiPut(`/magenta/stock/product/${id}`, request).then(result => result.response);
  },
  search(query) {
    return apiGet('/magenta/stock/product', query).then(result => result.response);
  },
  getProductById(id) {
    return apiGet(`/magenta/stock/product/${id}`).then(result => result.response);
  },
  // The variant groups the product is in, each with all its products and their names
  findVariantGroups(id) {
    return apiGet(`/magenta/stock/product/${id}/variant-groups`).then(result => result.response);
  },
  // Every group the product should be in: { id, productIds } without the product itself, and no id
  // for a group to create. It leaves the groups not sent
  updateVariantGroups(id, groups) {
    return apiPut(`/magenta/stock/product/${id}/variant-groups`, { groups })
      .then(result => result.response);
  },
  // The identical group the product is in, as a list: one, or more if set before the product form
  findIdenticalGroups(id) {
    return apiGet(`/magenta/stock/product/${id}/identical-groups`).then(result => result.response);
  },
  updateIdenticalGroup(id, productIds) {
    return apiPut(`/magenta/stock/product/${id}/identical-groups`, { productIds })
      .then(result => result.response);
  },
};
